import { Text, Flex, Image, useToast } from "@chakra-ui/react";
import Header from "../../../components/Header";
import { FiltroPedidos } from "../FiltroPedidos";
import { TableUsage } from "../Table";
import {
  atualizaPendenciaDevolucaoEtiqueta,
  listarDevolucoes,
} from "../../../services/api";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

const loading_verde = "../../images/loading-verde.gif";

const DevolucaoTrocaProducao = () => {
  const [infos, setInfos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isProduction, setIsProduction] = useState(true);

  const toast = useToast();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();

  async function submitForm(data) {
    setLoading(true);
    try {
      const dados = await listarDevolucoes.post("", data);
      setInfos(dados.data);
      setLoading(false);
    } catch (error) {
      console.log(Object.keys(error), error.message);
      setLoading(false);
    }
  }

  async function atualizaPendenciaEtiqueta(param) {
    const numero_venda = param.numero_venda;
    try {
      const response = await atualizaPendenciaDevolucaoEtiqueta.post("", param);
      const dados = response;
      toast({
        title: "Concluído com sucesso.",
        description: `Numero da venda: ${numero_venda}`,
        status: "success",
        duration: 9000,
        isClosable: true,
        position: "top",
      });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  }

  useEffect(() => {
    setIsProduction(true);
    submitForm({ pendente_etiqueta: "S" });
  }, []);

  return (
    <>
      <Flex flexDir="column">
        <Text
          paddingBlock="2rem"
          bg="#378BBF"
          textAlign="center"
          fontSize="1.2rem"
          color="white"
          fontWeight="bold"
        >
          Devolução/Troca Produção
        </Text>
        <FiltroPedidos
          isProduction={isProduction}
          register={register}
          handleSubmit={handleSubmit}
          submitForm={submitForm}
          errors={errors}
          isSubmitting={isSubmitting}
        />
        {loading ? (
          <Flex w="100%" h="calc(100vh - 600px)" bgColor="white">
            <Image m="auto auto" w="auto" h="100px" src={loading_verde} />
          </Flex>
        ) : (
          <TableUsage
            submitForm={submitForm}
            setLoading={setLoading}
            atualizaPendenciaEtiqueta={atualizaPendenciaEtiqueta}
            isProduction={isProduction}
            infos={infos}
          />
        )}
      </Flex>
    </>
  );
};

export default DevolucaoTrocaProducao;
